export default __webpack_public_path__ + "static/media/sport-100-els-moto.18ec78f9.png";